// extracted by mini-css-extract-plugin
export default {"fileLink":"FileLink_fileLink__N3ONR","filename":"FileLink_filename__KfxyK","button":"FileLink_button__59uIR"};